import React, { useEffect, useState } from 'react'

import { detectLangFromNavigator, getLocaleStatus, getNewLocaleUrl } from '@hozana/intl/functions'
import { useDispatch } from '@hozana/redux/hooks'
import { useRouter } from '@hozana/router'
import { cookie } from '@hozana/storage/cookies'
import { QA } from '@hozana/tests/constants'

import { Button } from 'elements/button/Button'

import { Locale } from 'config/types'
import { toggleLangBar } from 'general/actions'
import { getStoredLang } from 'general/functions'
import { COOKIES, COOKIES_CONFIG } from 'general/managers/cookies/constants'
import { FooterBanner } from 'general/structure/FooterBanner'
import { TLocale } from 'i18n/constants'

import { useUser } from 'modules/user/hooks/useUser'

const HOZANA_IN_LANG = {
  fr: 'Hozana en français',
  es: 'Hozana en español',
  en: 'Hozana in English',
  pt: 'Hozana em português',
  it: 'Hozana in italiano',
  pl: 'Hozana po polsku',
}

export const LangManager: TFC = () => {
  const { pathname, query, locale } = useRouter() // #router.replace
  const { isLogged, lang } = useUser()
  const dispatch = useDispatch()

  const [suggestedLang, setSuggestedLang] = useState<TLocale | null>(null)

  const userLang = isLogged ? lang : getStoredLang() || detectLangFromNavigator()

  // Display the lang banner
  useEffect(() => {
    if (
      userLang &&
      userLang !== locale &&
      getLocaleStatus(locale as Locale) === 'active' &&
      getLocaleStatus(userLang as Locale) === 'active' &&
      !cookie.load(COOKIES.hideBannerLang)
    ) {
      setSuggestedLang(userLang)
      dispatch(toggleLangBar(true))
    }
  }, [dispatch, locale, userLang])

  const close = () => {
    cookie.save(COOKIES.hideBannerLang, true, COOKIES_CONFIG.ONE_YEAR)
    setSuggestedLang(null)
    dispatch(toggleLangBar(false))
  }

  const withBanner = cookie.load<string>(COOKIES.withBanner)
  if (!suggestedLang || (withBanner && withBanner !== 'true' && !withBanner.includes('LangBanner'))) {
    return null
  }

  return (
    <FooterBanner name="lang" zIndex="langBanner" onClose={close}>
      <Button
        data-testid={QA.COMMON.BANNER.LANG.CHOOSE_SUGGESTED_BUTTON}
        size="bigger"
        valueLink={{
          to: getNewLocaleUrl({ pathname, query }),
          locale: suggestedLang,
          reload: true,
        }}
        onClick={close}
      >
        {HOZANA_IN_LANG[suggestedLang]} !
      </Button>
    </FooterBanner>
  )
}
